<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.mb-1
        DateRangePicker(:value="dateRange" @update="getData")
      .form-group.col-md-3.col-2
        b-input-group(size="sm")
          b-input-group-text(slot="prepend" :title="$t('ui.manual_bonus')")
            span {{ $t('ui.manual_bonus') }}
          b-input-group-text(slot="append")
            label.custom-switch
              input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="manualBonus" @change="getLogList(true)")
              span.custom-switch-indicator        
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getLogList(true)"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th.sortable(width="19%" @click="sortOrder('bonus_name')")
                  span(:title="$t('ui.bonus_name')") {{ $t('ui.bonus_name') }}
                  .float-right
                    i(:class="changeSortKey('bonus_name')")
                th.sortable(width="20%" @click="sortOrder('bonus_desc')")
                  span(:title="$t('ui.bonus_desc')") {{ $t('ui.bonus_desc') }}
                  .float-right
                    i(:class="changeSortKey('bonus_desc')")
                th.sortable(width="9%" @click="sortOrder('bonus_type')")
                  span(:title="$t('ui.bonus_type')") {{ $t('ui.bonus_type') }}
                  .float-right
                    i(:class="changeSortKey('bonus_type')")
                th.text-right.sortable(width="14%" @click="sortOrder('bonus_value')")
                  span(:title="$t('ui.bonus_value')") {{ $t('ui.bonus_value') }}
                  .float-right
                    i(:class="changeSortKey('bonus_value')")
                th.sortable(width="11%" @click="sortOrder('created_by')")
                  span(:title="$t('ui.created_by')") {{ $t('ui.created_by') }}
                  .float-right
                    i(:class="changeSortKey('created_by')")
                th.text-right.sortable(width="13%" @click="sortOrder('created_date')")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                  .float-right
                    i(:class="changeSortKey('created_date')")
            tbody.clusterize-content
              tr(v-if="logList.length == 0")
                td(:colspan="8").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in logList")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="item.bonus_name") {{ item.bonus_name }}&nbsp;
                td
                  span(:title="item.bonus_desc") {{ item.bonus_desc }}&nbsp;
                td
                  span(:title="item.bonus_type") {{ item.bonus_type }}&nbsp;
                td.text-right
                  span.font-weight-bold(:title="$n(item.bonus_value, 'currency')") {{ $n(item.bonus_value, 'currency') }}
                td
                  span(:title="item.created_by") {{ item.created_by }}&nbsp;
                td.text-right
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
              tr(v-if="showTotal")
                td.text-right(colspan="4")
                  span {{ $t("ui.sub_total") }}
                  br
                  span {{ $t("ui.grand_total") }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalBonus)" :title="$n(subTotalBonus, 'currency')") {{ $n(subTotalBonus, 'currency') }}
                  br
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonus)" :title="$n(grandTotalBonus, 'currency')") {{ $n(grandTotalBonus, 'currency') }}
                td(colspan="3")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcel from "@/library/jsonToExcelFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel
  },
  props: {
    currTab: {
      type: String,
      default: ''
    },
    operatorID: {
      type: String,
      default: ''
    },
    memberID: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    loading2: false,
    logList: [],
    logListFull: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    manualBonus: false,
    showTotal: false,
    subTotalBonus: 0,
    grandTotalBonus: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    sortKey: "created_date",
    sortType: "desc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeMemberLog;
    }
  },
  mounted: function() {},
  destroyed: function() {
    var json = {
      start_date: null,
      end_date: null,
      manual_bonus: false
    };
    this.$store.dispatch("user/setBonusLogParam", json);
  },
  methods: {
    refresh() {
      if (this.$store.getters.bonusLog.manual_bonus != null && this.$store.getters.bonusLog.manual_bonus != '') {
        this.manualBonus = this.$store.getters.bonusLog.manual_bonus;
      }
      if (this.$store.getters.bonusLog.start_date && this.$store.getters.bonusLog.end_date) {
        this.dateRange.startDate = this.$store.getters.bonusLog.start_date;
        this.dateRange.endDate = this.$store.getters.bonusLog.end_date;
      } else {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      }

      this.getLogList(true);
      this.getLogListFull();
    },
    setBonusLogParam: function() {
      var json = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        manual_bonus: this.manualBonus
      };
      this.$store.dispatch("user/setBonusLogParam", json);
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getLogList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getListing() {
      this.getLogList(true);
      this.getLogListFull();
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getLogList(true);
      this.getLogListFull();
    },
    getLogListFull: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.bonusListUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          member_id: this.memberID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          manual_bonus_only: this.manualBonus,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: -1
        };

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.logListFull = response.data.ds.summarydetail;
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }

    },
    getLogList: function(isSearch) {
      if (this.checkDateRange()) {
        this.setBonusLogParam();
        let url = config.bonusListUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          member_id: this.memberID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          manual_bonus_only: this.manualBonus,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal();
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.summarydetail.length > 0) {
                    this.showTotal = true;
                    response.data.ds.summarydetail.forEach(value => {
                      this.subTotalBonus = parseFloat(this.subTotalBonus) + parseFloat(value["bonus_value"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalBonus = response.data.ds.grand_total[0]["bonus_value"];
                    }

                    this.logList = response.data.ds.summarydetail;
                    this.totalRow = response.data.ds.summarydetail.length > 0 ? this.logList[0]["totalrows"] : 0
                  } else {
                    this.clearTotal();
                  }
                } else {
                  this.clearTotal()
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotal();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }

    },
    clearTotal() {
      this.showTotal = false
      this.logList = []
      this.logListFull = []
      this.totalRow = 0
      this.subTotalBonus = 0
      this.grandTotalBonus = 0
    },
    changedPageSize: function(pageSize) {
      if(this.currTab != 'bonuslog') return
      this.$store.dispatch("layout/setPageSizeMemberLog", pageSize);
      this.currentPage = 1;
      this.getLogList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getLogList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>